import React from "react";
import { Lookup, registerLookup, apiGet, Form } from "@redriver/cinnamon";

const NAMESPACE = "DEALERS/LOOKUPS";

const ActionTypes = {
  GetDealers: `${NAMESPACE}/GET_DEALERS`,
  GetTermsAndConditions: `${NAMESPACE}/GET_TERMS_AND_CONDITIONS`,
  GetDealerOffices: `${NAMESPACE}/GET_DEALER_OFFICES`,
};

const LookupTypes = {
  GetDealers: "dealersLookup",
  GetDealerOffices: "dealerOfficesLookup",
  TermsAndConditionsLookup: "termsAndConditionsLookup",
};

registerLookup(
  LookupTypes.GetDealers,
  ({ search, showSPV, includeFunderSuppliersOnly, funderId, pageSize = 10, pageNumber = 1 } = {}) =>
    apiGet(ActionTypes.GetDealers, "lookups/dealers", {
      search,
      pageSize,
      pageNumber,
      showSPV,
      includeFunderSuppliersOnly,
      funderId,
    }),
  {
    cache: false,
    transform: (data) =>
      data && Array.isArray(data)
        ? data.map(r => {
            return r.spv ? { value: r.value, text: r.text + " - " + r.spv  } :  { value: r.value, text: r.text } ;
          })
        : [],
  },
);

export const DealersTypeAheadLookup = props => (
  <Form.TypeAhead
    {...props}
    searchSuggestions
    alwaysShowSuggestionsOnBlur
    lookup={LookupTypes.GetDealers}
  />
);

const mapNode = (node, index = 0) => {
  const nodes = node.map((node) => ({
    value: node.value,
    text: node.text,
    children: [],
  }));

  return [{ text: "T&Cs", value: 1, defaultExpanded: false, children: nodes }];
};

registerLookup(
  LookupTypes.TermsAndConditionsLookup,
  () => apiGet(ActionTypes.GetTermsAndConditions, "lookups/boiler-plate-terms"),
  {
    transform: (data) => {
      return mapNode(data);
    },
  },
);

registerLookup(
  LookupTypes.GetDealerOffices,
  ({ search, dealerId, pageSize = 10, pageNumber = 1 } = {}) =>
    apiGet(ActionTypes.GetDealerOffices, "lookups/dealer-offices", {
      search,
      dealerId,
      pageSize,
      pageNumber,
    }),
  {
    cache: false,
    transform: (data) =>
      data && Array.isArray(data)
        ? data.map(r => {
            return r.spv ? { value: r.value, text: r.text + " - " + r.spv  } :  { value: r.value, text: r.text } ;
          })
        : [],
  },
);

export const DealerOfficesDropdownLookup = ({ className, dealerId, ...props }) => (
  <div className={className}>

    <Form.Dropdown
      search
      searchSuggestions
      alwaysShowSuggestionsOnBlur
      {...props}
      lookup={LookupTypes.GetDealerOffices}
      lookupParams={{ dealerId }}
    />
  </div>
);

export const DealersDropdownLookup = ({ className, ...props }) => (
  <div className={className}>
    <Form.Dropdown
      search
      searchSuggestions
      alwaysShowSuggestionsOnBlur
      {...props}
      lookup={LookupTypes.GetDealers}
    />
  </div>
);